import axios from 'axios'
import localStorageService from 'app/services/localStorageService';
/* 
const instance = axios.create();

instance.interceptors.request.use(
  function(config) {
    const store_id = localStorageService.getItem("store_id");
    const accessToken =  localStorageService.getItem("accessToken")
  
      config.headers["Authorization"] = 'Bearer ' + accessToken;
      config.headers["Ownerid"] = store_id?store_id:'null';
    
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

export default instance */


const instance = axios.create();

instance.interceptors.request.use(
  function (config) {
    const store_id = localStorageService.getItem("store_id");
    const accessToken = localStorageService.getItem("accessToken")

    instance.defaults.headers.common = {
      Authorization: `Bearer ${accessToken}`,
      "Ownerid": store_id ? store_id : 'null'
    };

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default instance

const axiosInstance = axios.create()



/* async function setHeader(){
    let store_id=await localStorageService.getItem("store_id")
    console.log("owner Id",store_id)
    const accessToken = await localStorageService.getItem("accessToken")
    axiosInstance.defaults.headers.common = {
        Authorization: `Bearer ${accessToken}`,
        "Ownerid": store_id?store_id:'null'
    };
}
 

setHeader()


export default axiosInstance  */
